
<template>
  <button @click="onClick" class="startup-item" v-if="startup">
    <div class="row no-gutters">
      <div class="col-3 col-logo">
        <div
          class="logo"
          :style="`background-image: url('${startup.logo}');background-size:contain;background-position:center;`"
        />
      </div>
      <div class="col data-container">
        <div class="row">
          <div class="col-5 col-md-2 up item-data">
            <h1>{{startup.name}}</h1>
            <h4 class="d-none d-md-block vertical">{{verticalPrincipal}}</h4>
          </div>
          <div class="col-7 item-data vertical up d-flex d-md-none">
            <h4 v-if="verticalPrincipal">{{verticalPrincipal}}</h4>
          </div>
          <div class="col-12 col-md-10">
            <div class="row">
              <div class="col-5 col-md-4 col-lg item-data">
                <h4>Valuación</h4>
                <p>
                  <span>U$D</span>
                  {{numberWithDots(startup.basic.valuacion)}}
                </p>
              </div>
              <div class="col-6 col-md-4 col-lg item-data">
                <h4>Inversión externa</h4>
                <p>
                  <span>U$D</span>
                  {{numberWithDots(startup.basic.inversion_externa)}}
                </p>
              </div>
              <div class="col-5 col-md-4 col-lg item-data mt-1 mt-md-0">
                <h4>Valuación {{fund}}</h4>
                <p>
                  <span>U$D</span>
                  {{numberWithDots(gridValuation)}}
                </p>
              </div>
              <div class="col-6 col-md-4 col-lg item-data mt-1 mt-lg-0">
                <h4>Invertido {{fund}}</h4>
                <p>
                  <span>U$D</span>
                  {{numberWithDots(gridInvested)}}
                </p>
              </div>
              <div class="col-md-1 item-data d-none d-md-block mt-1 mt-lg-0">
                <h4>Batch</h4>
                <p>{{startup.basic.batch}}</p>
              </div>
              <div class="col-md item-data d-none d-md-block other-links">
                <!-- eslint-disable max-len -->
                <SecondaryButton @click="openOnepager" class="btn" v-if="startup.one_pager">Onepager</SecondaryButton>
              </div>
            </div>
          </div>
        </div>
        <ChevronRight class="chevron-right d-block d-md-none" />
      </div>
    </div>
  </button>
</template>

<script>
import ChevronRight from '../assets/icons/chevron-right.svg';
import SecondaryButton from './Button/SecondaryButton.vue';
import { numberWithDots } from '../helpers/numbers';

export default {
  name: 'StartupItem',
  components: {
    ChevronRight,
    SecondaryButton,
  },
  props: {
    openSidepanel: Function,
    startup: Object,
  },
  computed:{
    selectedFondo() {
      return this.$store.state.selectedFondo;
    },
    fund(){
      if(this.selectedFondo === 'GRIDX2') return 'Fund II';
      return 'Fund I';
    },
    gridInvested(){
      let invertido = 0;

      if(this.selectedFondo === 'GRIDX2') {
        invertido = this.startup.basic.invertido_gridx_2 + this.startup.basic.invertido_gridx_2_follow;
      } else {
        invertido = this.startup.basic.invertido_gridx + this.startup.basic.invertido_gridx_follow;
      }

      return invertido;
    },
    gridValuation(){
      let gridxInvestor = null;

      if(this.selectedFondo === 'GRIDX2') {
        gridxInvestor = this.startup.basic.inversores.find(x => x.name.toUpperCase() === 'GridX - Fund II'.toUpperCase());
      } else {
        gridxInvestor = this.startup.basic.inversores.find(x => x.name.toUpperCase() === 'GridX'.toUpperCase());
      }

      const gridxPercentage = gridxInvestor ? gridxInvestor.porcentaje_participacion : 100 || 100;
      return (+gridxPercentage * (+this.startup.basic.valuacion)) / 100;
    },
    verticalPrincipal(){
      if(this.startup.verticales.length > 0){
        return this.startup.verticales[0].name;
      }
      
      return '';
    },
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      numberWithDots,
    };
  },
  methods: {
    onClick() {
      this.openSidepanel(true, this.startup);
      // this.$router.push({ name: 'Startup', params: { id: '123' } });
    },
    openWeb() {
      setTimeout(() => this.openSidepanel(false), 100);
      window.open(this.startup.website, '_blank');
    },
    openOnepager() {
      setTimeout(() => this.openSidepanel(false), 100);
      window.open(this.startup.one_pager, '_blank');
    },
  },
};
</script>

<style scoped lang="scss">
.chevron-right {
  right: -10px;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  width: 34px;
}

.startup-item {
  width: 100%;
  background: #fff;
  border-radius: 8px;
  padding: 18px;
  margin-bottom: 16px;
  font-family: "Montserrat", sans-serif;
  border: none;
  display: block;
  text-align: left;
  cursor: pointer;

  &:hover {
    box-shadow: 1px 1px 4px #dedddf;
  }
}

.other-links {
  padding-right: 5% !important;

  .btn {
    margin: 0 auto;
    display: block;
    margin-top: 15px;
    @media (min-width: 992px) {
      float: right;
      margin-top: 5px;
      display: inherit;
    }
  }
}

.logo {
  width: 64px;
  height: 64px;
  border: 1px solid rgba(0, 0, 0, 0.07);
  border-radius: 8px;
  background-size: cover;
  background-repeat: no-repeat;

  @media (min-width: 768px) {
    width: 80px;
    height: 80px;
  }
}

.data-container {
  padding-left: 15px;

  @media (min-width: 768px) {
    padding-top: 20px;
  }

  .up {
    margin-bottom: 5px;

    @media (min-width: 768px) {
      margin-bottom: 0;
    }
  }
}

.col-logo {
  -ms-flex: 0 0 64px;
  flex: 0 0 64px;
  max-width: 64px;

  @media (min-width: 768px) {
    -ms-flex: 0 0 80px;
    flex: 0 0 80px;
    max-width: 80px;
  }
}

h1 {
  font-weight: 600;
  font-size: 12px;
  color: #330e2f;
  margin: 3px 0;

  @media (min-width: 364px) {
    font-size: 14px;
  }

  @media (min-width: 768px) {
    font-size: 16px;
    margin-top: -2px;
  }
}

.item-data {
  padding-right: 0;

  &.vertical,
  .vertical {
    text-transform: uppercase;
    margin-top: 2px;
    color: #330e2f;

    @media (min-width: 768px) {
      margin-top: 10px;
      background: #330e2f33;
      border-radius: 4px;
      padding: 0 5px;
      margin-top: 7px;
      height: fit-content;
      width: fit-content;
    }

    h4 {
      color: #330e2f;
      background: #330e2f33;
      border-radius: 4px;
      padding: 0 5px;
      margin-top: 2px;
      height: fit-content;
    }
  }

  h4 {
    font-size: 9px;
    color: #979797;
    margin: 0;
    font-weight: 300;
    line-height: 2;

    @media (min-width: 364px) {
      font-size: 10px;
    }
  }
  p {
    font-size: 10px;
    color: #330e2f;
    margin: 0;
    font-weight: 600;
    @media (min-width: 364px) {
      font-size: 14px;
    }

    span {
      font-size: 7px;
      margin-right: 3px;

      @media (min-width: 364px) {
        font-size: 9px;
      }
    }
  }
}
</style>
